import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/shidaologo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src={logo} alt="识道造价" />
            <span>识道造价</span>
          </Link>

          <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
            <Link 
              to="/" 
              className={isActive('/') ? 'active' : ''}
              onClick={handleNavClick}
            >
              首页
            </Link>
            <div className="nav-dropdown">
              <span className={location.pathname.startsWith('/services') ? 'active' : ''}>
                服务项目
              </span>
              <div className="dropdown-menu">
                <Link to="/services#investment" onClick={handleNavClick}>投资估算咨询、编制及审核服务</Link>
                <Link to="/services#design" onClick={handleNavClick}>设计概算咨询、编制及审核服务</Link>
                <Link to="/services#budget" onClick={handleNavClick}>工程预算咨询、编制及审核服务</Link>
                <Link to="/services#settlement" onClick={handleNavClick}>工程结算咨询、编制及审核服务</Link>
                <Link to="/services#other" onClick={handleNavClick}>工程其他费咨询、编制及审核服务</Link>
                <Link to="/services#final" onClick={handleNavClick}>项目决算咨询、编制及审核服务</Link>
                <Link to="/services#tendering" onClick={handleNavClick}>招投标代理服务、政府采购代理服务</Link>
                <Link to="/services#procurement" onClick={handleNavClick}>采购业务代理服务</Link>
              </div>
            </div>
            <Link 
              to="/projects" 
              className={isActive('/projects') ? 'active' : ''}
              onClick={handleNavClick}
            >
              成功案例
            </Link>
            <div className="nav-dropdown">
              <span className={location.pathname.startsWith('/platform') ? 'active' : ''}>
                数智平台
              </span>
              <div className="dropdown-menu">
                <Link to="/platform#ai" onClick={handleNavClick}>AI智能审核平台</Link>
                <Link to="/platform#bim" onClick={handleNavClick}>BIM+造价一体化平台</Link>
                <Link to="/platform#control" onClick={handleNavClick}>全过程造价管控平台</Link>
              </div>
            </div>
            <Link
              to="/notices"
              className={location.pathname.startsWith('/notices') ? 'active' : ''}
              onClick={handleNavClick}
            >
              通知公告
            </Link>
            <Link 
              to="/careers" 
              className={isActive('/careers') ? 'active' : ''}
              onClick={handleNavClick}
            >
              加入我们
            </Link>
            <div className="nav-dropdown">
              <span className={location.pathname.startsWith('/about') ? 'active' : ''}>
                关于我们
              </span>
              <div className="dropdown-menu">
                <Link to="/about#intro" onClick={handleNavClick}>公司简介</Link>
                <Link to="/about#qualifications" onClick={handleNavClick}>资质荣誉</Link>
                <Link to="/about#team" onClick={handleNavClick}>团队介绍</Link>
              </div>
            </div>
            <Link 
              to="/contact" 
              className={`contact-btn ${isActive('/contact') ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              联系我们
            </Link>
          </nav>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

